module.exports = __webpack_public_path__ + "res/24-img_collect_value.9e2471742688eb2cfd675c3a8d804b70.png";